import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-checkout-failed-page',
  templateUrl: './checkout-failed-page.component.html',
  styleUrls: ['./checkout-failed-page.component.css']
})
export class CheckoutFailedPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
   $('#initialise-page').trigger('click');
  }

}
